// extracted by mini-css-extract-plugin
module.exports = {"customRadio":"radio_customRadio__v1svO","customRadioButton":"radio_customRadioButton__KE57O"};